import { styled } from "@mui/material/styles";
const Container = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-evenly"
}));
const WorkingDay = styled("div")(() => ({
  textAlign: "center",
  display: "flex",
  flexDirection: "column"
}));
const Day = styled("span")(({ theme }) => ({
  fontSize: 14,
  fontWeight: 400,
  lineHeight: "20px",
  letterSpacing: 0.25,
  color: theme.palette.grey[800],
  fontFamily: "Lato"
}));
const Month = styled("span")(({ theme }) => ({
  fontSize: 14,
  fontWeight: 700,
  lineHeight: "20px",
  letterSpacing: 0.25,
  color: theme.palette.grey[800],
  fontFamily: "Lato"
}));
export {
  Container,
  Day,
  Month,
  WorkingDay
};
